import { render, staticRenderFns } from "./CommonListLeaveReport.vue?vue&type=template&id=72518708"
import script from "./CommonListLeaveReport.vue?vue&type=script&lang=js"
export * from "./CommonListLeaveReport.vue?vue&type=script&lang=js"
import style0 from "./CommonListLeaveReport.vue?vue&type=style&index=0&id=72518708&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports